import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MenuRoute, MenuTemplate } from './menu-route.model';
import { ALL_MENU_ROUTES, ALL_MENU_TEMPLATES } from './menu-route-registry';

/**
 * Source of truth for the menu admin route picker.
 * Wraps the static `ALL_MENU_ROUTES` aggregate as an Observable so consumers can later
 * be migrated to a dynamic source (e.g. backend manifest endpoint) without changing call sites.
 */
@Injectable({ providedIn: 'root' })
export class MenuRouteRegistryService {
  private readonly routes: MenuRoute[] = ALL_MENU_ROUTES;
  private readonly templates: MenuTemplate[] = ALL_MENU_TEMPLATES;

  /** All registered menu-eligible routes. */
  routes$(): Observable<MenuRoute[]> {
    return of(this.routes);
  }

  /** Synchronous accessor for the full list. */
  getAll(): MenuRoute[] {
    return this.routes;
  }

  /** Look up a single route by its absolute path. */
  getByPath(path: string): MenuRoute | undefined {
    return this.routes.find(r => r.path === path);
  }

  /** All routes belonging to a given moduleId (matches `wv_Module.moduleID`). */
  getByModule(moduleId: number): MenuRoute[] {
    return this.routes.filter(r => r.moduleId === moduleId);
  }

  /** All registered default menu templates (Phase 6). */
  getAllTemplates(): MenuTemplate[] {
    return this.templates;
  }

  /** Look up a module's default menu template, if one has been declared. */
  getTemplate(moduleId: number): MenuTemplate | undefined {
    return this.templates.find(t => t.moduleId === moduleId);
  }
}
